import {
	queryOptions,
	useMutation,
	useQueryClient,
} from '@tanstack/react-query';

import { api } from '#client';
import { parseSchema } from '#client/validation';

import { claimQueries } from './claims';
import {
	Questionnaire,
	QuestionnaireBody,
	QuestionnaireResponse,
} from './questionnaire.types';

const getQuestionnaireData = (claimId: string) =>
	api
		.get(`/claims/claim/${claimId}/questionnaire`)
		.then(parseSchema(Questionnaire));

export const questionnaireQueries = {
	id: (claimId: string) =>
		queryOptions({
			queryKey: [...claimQueries.ids(), claimId, 'questionnaire'],
			queryFn: () => getQuestionnaireData(claimId),
		}),
};

const postQuestionnaire = (params: QuestionnaireBody) =>
	api
		.post(`/claims/questionnaire`, { json: params })
		.then(parseSchema(QuestionnaireResponse));

export const useSaveQuestionnaireMutate = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (params: QuestionnaireBody) => postQuestionnaire(params),
		onSuccess: (_, params) =>
			Promise.all([
				queryClient.invalidateQueries({
					queryKey: [
						...claimQueries.ids(),
						String(params.questionnaireData.claimId),
					],
				}),
			]),
	});
};
